__turbopack_context__.v({
  "closeIcon": "vzGZ_q_closeIcon",
  "content": "vzGZ_q_content",
  "footer": "vzGZ_q_footer",
  "large": "vzGZ_q_large",
  "medium": "vzGZ_q_medium",
  "modal": "vzGZ_q_modal",
  "small": "vzGZ_q_small",
});
